export function numberWithCommas(x: number | string): string {
  // First round down to two decimal places
  const rounded = Math.floor(Number(x) * 100) / 100;

  // Convert to string and format with commas
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
